import { Pipe, PipeTransform } from '@angular/core';
import { MenuModel } from '../models/menu.model';

@Pipe({
  standalone: true, name: 'sortbyPipe'
})
export class SortbyPipe implements PipeTransform {
  transform(list: MenuModel[]): any {
    return list.sort((a, b) => {
      return a['order'] > b['order'] ? 1 : -1;
    });

  }
}
